/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpsertTeamDto
 */
export interface UpsertTeamDto {
    /**
     * The name of the team.
     * @type {string}
     * @memberof UpsertTeamDto
     */
    name: string;
}

/**
 * Check if a given object implements the UpsertTeamDto interface.
 */
export function instanceOfUpsertTeamDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function UpsertTeamDtoFromJSON(json: any): UpsertTeamDto {
    return UpsertTeamDtoFromJSONTyped(json, false);
}

export function UpsertTeamDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertTeamDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function UpsertTeamDtoToJSON(value?: UpsertTeamDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

